<div class="dash-main-content">
  <div class="content-wrapper">
    <h3>Créer un utilisateur</h3>

    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="tabs">
        <div class="wizard" role="tablist" aria-label="Example Tabs">
          <button type="button" role="tab" [attr.aria-selected]="activeTab === 1" aria-controls="panel-1" id="tab-1"
            class="wizard-item" [class.complet]="activeTab > 1" [class.active]="activeTab === 1" (click)="goToTab(1)">
            <div class="wizard-item-icon"></div>
            <span class="wizard-name">Informations personnelles</span>
            <div class="wizard-only-mobile">1/3</div>
          </button>

          <button type="button" role="tab" [attr.aria-selected]="activeTab === 2" aria-controls="panel-2" id="tab-2"
            class="wizard-item" [class.complet]="activeTab > 2" [class.active]="activeTab === 2" (click)="goToTab(2)">
            <div class="wizard-item-icon"></div>
            <span class="wizard-name">Affectation des rôles</span>
            <div class="wizard-only-mobile">2/3</div>
          </button>

          <button type="button" role="tab" [attr.aria-selected]="activeTab === 3" aria-controls="panel-3" id="tab-3"
            class="wizard-item" [class.ended]="activeTab === 3" [class.active]="activeTab === 3" (click)="goToTab(3)">
            <div class="wizard-item-icon"></div>
            <span class="wizard-name">Validation</span>
            <div class="wizard-only-mobile">3/3</div>
          </button>
        </div>

        <div class="tab-panels">
          <!-- ═══════════════════════════════════════════════════════════════ -->
          <!-- Panel 1 : Informations personnelles                            -->
          <!-- ═══════════════════════════════════════════════════════════════ -->
          <div id="panel-1" class="tab-panel" [class.active]="activeTab === 1" [hidden]="activeTab !== 1"
            role="tabpanel" aria-labelledby="tab-1">

            <h4>Informations personnelles</h4>

            <!-- Champs de base sur 2 colonnes -->
            <div class="form-groups">
              <div class="field-wrapper">
                <label for="username">Nom d'utilisateur (pseudo) *</label>
                <input type="text" id="username" class="field" placeholder="Un pseudo" formControlName="username"
                  [class.error]="userForm.get('username')?.invalid && userForm.get('username')?.touched">
                  @if (userForm.get('username')?.invalid && userForm.get('username')?.touched) {
                    <div class="error-message"
                      >
                      @if (userForm.get('username')?.errors?.['required']) {
                        <span>Le nom d'utilisateur est requis</span>
                      }
                      @if (userForm.get('username')?.errors?.['minlength']) {
                        <span>Minimum 3 caractères</span>
                      }
                    </div>
                  }
                </div>

                <div class="field-wrapper">
                  <label for="email">Adresse e-mail *</label>
                  <input type="email" id="email" class="field" placeholder="sophia.fall&#64;gouv.sn"
                    formControlName="email"
                    [class.error]="userForm.get('email')?.invalid && userForm.get('email')?.touched">
                    @if (userForm.get('email')?.invalid && userForm.get('email')?.touched) {
                      <div class="error-message">
                        @if (userForm.get('email')?.errors?.['required']) {
                          <span>L'email est requis</span>
                        }
                        @if (userForm.get('email')?.errors?.['email']) {
                          <span>Format d'email invalide</span>
                        }
                      </div>
                    }
                  </div>

                  <div class="field-wrapper">
                    <label for="firstName">Prénom *</label>
                    <input type="text" id="firstName" class="field" placeholder="Prénom" formControlName="firstName"
                      [class.error]="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched">
                      @if (userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched) {
                        <div class="error-message"
                          >
                          Le prénom est requis
                        </div>
                      }
                    </div>

                    <div class="field-wrapper">
                      <label for="lastName">Nom *</label>
                      <input type="text" id="lastName" class="field" placeholder="Nom" formControlName="lastName"
                        [class.error]="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched">
                        @if (userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched) {
                          <div class="error-message"
                            >
                            Le nom est requis
                          </div>
                        }
                      </div>
                    </div>

                    <!-- Type d'utilisateur — pleine largeur -->
                    <div class="field-wrapper full-width">
                      <label for="userType">Type d'utilisateur *</label>
                      <select id="userType" class="field" formControlName="userType">
                        @for (type of allowedUserTypes; track type) {
                          <option [value]="type.value">
                            {{ type.label }}
                          </option>
                        }
                      </select>
                    </div>

                    <!-- ─────────────────────────────────────────────────────────── -->
                    <!-- Sigle IES  +  Sigle Établissement                           -->
                    <!-- Affichés uniquement quand le type n'est pas SUPER_ADMIN     -->
                    <!-- ─────────────────────────────────────────────────────────── -->
                    @if (selectedUserType !== 'SCA_SUPER_ADMIN' &&  selectedUserType !== 'SCA_ADMIN_AUTRE_ENTITE') {
                      <div class="sigle-row">
                        <!-- Sigle IES -->
                        <div class="field-wrapper">
                          <label for="sigleIes">
                            Sigle de l'IES *
                            @if (isLoadingIes) {
                              <span class="loading-hint">Chargement…</span>
                            }
                          </label>
                          <!-- Cas SUPER_ADMIN : champ de recherche + dropdown liste déroulante-->
                          @if (!isCurrentUserIesAdmin) {
                            <div id="ies-multiselect" class="custom-multiselect"
                              [class.open]="isIesDropdownOpen" [class.disabled]="isLoadingIes"
                              [class.error]="userForm.get('sigleIes')?.invalid && userForm.get('sigleIes')?.touched">
                              <div class="multiselect-trigger field" (click)="toggleIesDropdown()">
                                <span class="selected-values" [class.placeholder]="!userForm.get('sigleIes')?.value">
                                  {{ isLoadingIes ? 'Chargement...' : (getSelectedIesLabel() || 'Sélectionnez une IES') }}
                                </span>
                                <span class="dropdown-arrow">
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                  </svg>
                                </span>
                              </div>
                              @if (isIesDropdownOpen) {
                                <div class="multiselect-dropdown">
                                  <div class="dropdown-search">
                                    <input type="text" class="field search-input" placeholder="Rechercher une IES..."
                                      [formControl]="iesSearchControl" (click)="$event.stopPropagation()">
                                    </div>
                                    <div class="dropdown-options">
                                      @for (ies of filteredIesList; track ies) {
                                        <label class="option-item">
                                          <input type="checkbox" [value]="ies.sigle" [checked]="isIesSelected(ies.sigle)"
                                            (change)="selectIes(ies.sigle)">
                                            <span>{{ ies.label }}</span>
                                          </label>
                                        }
                                        @if (filteredIesList.length === 0) {
                                          <div class="no-options">
                                            Aucune IES trouvée
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                              <!-- Cas IES_ADMIN connecté : champ désactivé pré-rempli -->
                              @if (isCurrentUserIesAdmin) {
                                <input type="text" id="sigleIes" class="field"
                                  [value]="userForm.get('sigleIes')?.value || ''" disabled>
                              }
                              @if (userForm.get('sigleIes')?.invalid && userForm.get('sigleIes')?.touched) {
                                <div class="error-message"
                                  >
                                  Le sigle IES est requis
                                </div>
                              }
                            </div>
                            <!-- Sigle Établissement — visible uniquement pour ETABLISSEMENT_ADMIN -->
                            <!-- <div class="field-wrapper" *ngIf="selectedUserType === 'SCA_ETABLISSEMENT_ADMIN'">
                            <label for="sigleEtablissement">
                              Sigle de l'établissement *
                              <span class="loading-hint" *ngIf="isLoadingEtab">Chargement…</span>
                            </label>
                            <select id="sigleEtablissement" class="field" formControlName="sigleEtablissement"
                              [class.error]="userForm.get('sigleEtablissement')?.invalid && userForm.get('sigleEtablissement')?.touched">
                              <option [ngValue]="null" disabled selected>
                                <ng-container *ngIf="!userForm.get('sigleIes')?.value">
                                  Sélectionnez d'abord une IES
                                </ng-container>
                                <ng-container *ngIf="userForm.get('sigleIes')?.value && isLoadingEtab">
                                  Chargement...
                                </ng-container>
                                <ng-container
                                  *ngIf="userForm.get('sigleIes')?.value && !isLoadingEtab && etablissementsList.length === 0">
                                  Aucun établissement disponible
                                </ng-container>
                                <ng-container
                                  *ngIf="userForm.get('sigleIes')?.value && !isLoadingEtab && etablissementsList.length > 0">
                                  Sélectionnez un établissement
                                </ng-container>
                              </option>
                              <option *ngFor="let etab of etablissementsList" [value]="etab.sigle">
                                {{ etab.label }}
                              </option>
                            </select>
                            <div class="error-message"
                              *ngIf="userForm.get('sigleEtablissement')?.invalid && userForm.get('sigleEtablissement')?.touched">
                              L'établissement est requis
                            </div>
                          </div> -->
                          @if (selectedUserType === 'SCA_ETABLISSEMENT_ADMIN') {
                            <div class="field-wrapper">
                              <label for="sigleEtablissements">
                                Établissements *
                                @if (isLoadingEtab) {
                                  <span class="loading-hint">Chargement des établissements...</span>
                                }
                              </label>
                              <!-- Conteneur du champ personnalisé -->
                              <div id="etab-multiselect" class="custom-multiselect" [class.open]="isEtabDropdownOpen"
                                [class.disabled]="isLoadingEtab"
                                [class.error]="userForm.get('sigleEtablissement')?.invalid && userForm.get('sigleEtablissement')?.touched">
                                <!-- Zone d'affichage des valeurs sélectionnées (comme un champ field) -->
                                <div class="multiselect-trigger field" (click)="!isLoadingEtab && toggleEtabDropdown()">
                                  <span class="selected-values">
                                    {{ getSelectedEtablissementsLabels() || 'Choisir des établissements' }}
                                  </span>
                                  <span class="dropdown-arrow">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                      stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                      <polyline points="6 9 12 15 18 9"></polyline>
                                    </svg>
                                  </span>
                                </div>
                                <!-- Liste déroulante avec recherche -->
                                @if (isEtabDropdownOpen) {
                                  <div class="multiselect-dropdown">
                                    <div class="dropdown-search">
                                      <input type="text" class="field search-input" placeholder="Rechercher un établissement..."
                                        [formControl]="etabSearchControl" (click)="$event.stopPropagation()">
                                      </div>
                                      <div class="dropdown-options">
                                        <!-- Ligne "Sélectionner tout" — applique sur la liste filtrée -->
                                        @if (filteredEtabList.length > 0) {
                                          <label class="option-item option-item--select-all">
                                            <input type="checkbox" [checked]="isAllEtabSelected()" [indeterminate]="isSomeEtabSelected()"
                                              (change)="toggleAllEtab($event)">
                                              <span>
                                                Sélectionner tout
                                                @if (etabSearchControl.value) {
                                                  <em>({{ filteredEtabList.length }} filtré(s))</em>
                                                }
                                                @if (!etabSearchControl.value) {
                                                  <em>({{ etablissementsList.length }})</em>
                                                }
                                              </span>
                                            </label>
                                          }
                                          @if (filteredEtabList.length > 0) {
                                            <div class="dropdown-divider"></div>
                                          }
                                          <!-- Liste des établissements -->
                                          @for (etab of filteredEtabList; track etab) {
                                            <label class="option-item">
                                              <input type="checkbox" [value]="etab.sigle" [checked]="isEtabSelected(etab.sigle)"
                                                (change)="toggleEtabSelection(etab.sigle, $event)">
                                                <span>{{ etab.label }}</span>
                                              </label>
                                            }
                                            @if (filteredEtabList.length === 0) {
                                              <div class="no-options">
                                                Aucun établissement trouvé
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      }
                                    </div>
                                    @if (userForm.get('sigleEtablissement')?.invalid && userForm.get('sigleEtablissement')?.touched) {
                                      <div class="error-message"
                                        >
                                        <span>Au moins un établissement est requis</span>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            <div class="two-buttons">
                              <button type="button" class="button neutral" (click)="onCancel()">Annuler</button>
                              <button type="button" class="button primary" (click)="goToNextTab()">Suivant</button>
                            </div>
                          </div>
                        </div>

                        <!-- ═══════════════════════════════════════════════════════════════ -->
                        <!-- Panel 2 : Affectation des rôles                               -->
                        <!-- ═══════════════════════════════════════════════════════════════ -->
                        <div id="panel-2" class="tab-panel" [class.active]="activeTab === 2" [hidden]="activeTab !== 2" role="tabpanel"
                          aria-labelledby="tab-2">

                          <div class="flex align-center justify-between gap-8 flex-wrap m-b-24">
                            <h4 class="m-b-4">Affectation des rôles</h4>
                            <div class="flex align-center justify-between gap-16 flex-wrap">
                              @if (getTotalSelectedRoles() > 0) {
                                <strong class="text-warning">
                                  {{ getTotalSelectedRoles() }} rôle(s) sélectionné(s)
                                </strong>
                              }
                              <div>
                                <input type="checkbox" id="reset-roles" [checked]="getTotalSelectedRoles() === 0"
                                  (change)="resetAllRoles()" [disabled]="getTotalSelectedRoles() === 0">
                                  <label for="reset-roles">Réinitialiser</label>
                                </div>
                              </div>
                            </div>

                            @if (applications.length > 0) {
                              <div class="card card-20">
                                <div class="accordion-wrapper">
                                  @for (app of applications; track app) {
                                    <div class="accordion-item">
                                      <button class="accordion" type="button" (click)="toggleAccordion(app.id)"
                                        [class.partially-selected]="isAppPartiallySelected(app)"
                                        [class.fully-selected]="isAppFullySelected(app)">
                                        {{ (app.name || app.id) | titlecase }}
                                        <span>({{ getSelectedRolesCount(app) }} rôles sur {{ app.roles?.length || 0 }})</span>
                                      </button>
                                      <div class="panel" [style.display]="isAppExpanded(app.id) ? 'block' : 'none'">
                                        <div class="accordion-checkbox">
                                          @if (app.roles && app.roles.length > 0) {
                                            <div class="flex align-center gap-8">
                                              <input type="checkbox" [id]="'select-all-' + app.id" [checked]="isAppFullySelected(app)"
                                                [indeterminate]="isAppPartiallySelected(app)" (change)="toggleAppSelection(app, $event)">
                                                <label [for]="'select-all-' + app.id">Sélectionner tous les rôles</label>
                                              </div>
                                            }
                                            @for (role of app.roles; track role) {
                                              <div class="flex align-center gap-8">
                                                <input type="checkbox" [id]="app.id + '-' + role.id" [checked]="isRoleSelected(app, role)"
                                                  (change)="toggleRoleSelection(app, role, $event)">
                                                  <label [for]="app.id + '-' + role.id">{{ role.title || role.name }}</label>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                } @else {
                                  <div class="card card-20 text-center p-32">
                                    <p class="text-muted">Aucune application disponible</p>
                                  </div>
                                }


                                <div class="two-buttons">
                                  <button type="button" class="button neutral" (click)="goToPreviousTab()">Précédent</button>
                                  <button type="button" class="button primary" (click)="goToNextTab()">Suivant</button>
                                </div>
                              </div>

                              <!-- ═══════════════════════════════════════════════════════════════ -->
                              <!-- Panel 3 : Validation / Récapitulatif                          -->
                              <!-- ═══════════════════════════════════════════════════════════════ -->
                              <div id="panel-3" class="tab-panel" [class.active]="activeTab === 3" [hidden]="activeTab !== 3" role="tabpanel"
                                aria-labelledby="tab-3">

                                <h4>Récapitulatif</h4>

                                <div class="m-b-24">
                                  <h6>Informations personnelles</h6>
                                  <div class="card-infos">
                                    <div class="key-value">
                                      <span>Pseudo</span>
                                      <p>{{ userForm.get('username')?.value || '-' }}</p>
                                    </div>
                                    <div class="key-value">
                                      <span>Adresse e-mail</span>
                                      <p>{{ userForm.get('email')?.value || '-' }}</p>
                                    </div>
                                    <div class="key-value">
                                      <span>Prénom</span>
                                      <p>{{ userForm.get('firstName')?.value || '-' }}</p>
                                    </div>
                                    <div class="key-value">
                                      <span>Nom</span>
                                      <p>{{ userForm.get('lastName')?.value || '-' }}</p>
                                    </div>
                                    @if (selectedUserType !== 'SCA_SUPER_ADMIN') {
                                      <div class="key-value">
                                        <span>IES</span>
                                        <p>{{ userForm.getRawValue().sigleIes || '-' }}</p>
                                      </div>
                                    }
                                    @if (selectedUserType === 'SCA_ETABLISSEMENT_ADMIN') {
                                      <div class="key-value">
                                        <span>Établissements</span>
                                        <p>{{ getSelectedEtablissementsLabels() || '-' }}</p>
                                      </div>
                                    }
                                  </div>
                                </div>

                                <div class="m-b-24">
                                  <h6>Rôles affectés</h6>
                                  @if (getTotalSelectedRoles() > 0) {
                                    <div class="card card-20">
                                      <div class="accordion-wrapper">
                                        @for (app of selectedApplications; track app) {
                                          <div class="accordion-item">
                                            @if (getSelectedRolesCount(app) > 0) {
                                              <button class="accordion" type="button" (click)="toggleAccordion('summary-' + app.id)">
                                                {{ app.name }}
                                                <span>({{ getSelectedRolesCount(app) }} rôle(s))</span>
                                              </button>
                                              <div class="panel" [style.display]="isAppExpanded('summary-' + app.id) ? 'block' : 'none'">
                                                <div class="accordion-checkbox">
                                                  @for (role of app.roles; track role) {
                                                    <div class="flex align-center gap-8">
                                                      @if (isRoleSelected(app, role)) {
                                                        <div class="selected-role-item">
                                                          <input type="checkbox" checked disabled>
                                                          <span>{{ role.name }}</span>
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  } @else {
                                    <p class="text-muted">Aucun rôle sélectionné</p>
                                  }
                                </div>

                                <div class="two-buttons">
                                  <button type="button" class="button neutral" (click)="goToPreviousTab()">Précédent</button>
                                  <button type="submit" class="button primary" [disabled]="isLoading || !userForm.valid">
                                    {{ isLoading ? 'Enregistrement...' : 'Enregistrer' }}
                                  </button>
                                </div>
                              </div>

                            </div>
                          </form>
                        </div>
                      </div>

                      <!-- Snackbar -->
                      <div class="snackbar" [class.show]="showSnackbar" [class.success-snackbar]="!isErrorSnackbar"
                        [class.error-snackbar]="isErrorSnackbar">
                        <div class="snackbar-content">
                          <i class="material-icons snackbar-icon">{{ isErrorSnackbar ? 'error' : 'check_circle' }}</i>
                          <span class="snackbar-message">{{ snackbarMessage }}</span>
                          <button class="snackbar-close" (click)="hideSnackbar()">
                            <i class="material-icons">close</i>
                          </button>
                        </div>
                      </div>
